export default __webpack_public_path__ + "static/media/perryLoud.addf8e3f.mp3";